<template>
  <div class="drawer">
    <el-drawer
      size="650px"
      :visible.sync="drawerStatus"
      @close="close"
      :title="'欠宠退款'"
      :wrapperClosable="false"
    >
      <div class="msgBox">
        <span>转换余额:</span>
        <div class="msgBoxL">
          <el-radio v-model="isReturnYuE" label="true">是</el-radio>
          <el-radio v-model="isReturnYuE" label="false">否</el-radio>
        </div>
      </div>
      <div class="msgBox" v-show="isReturnYuE == 'false'">
        <div style="margin-left: 50px; vertical-align: middle">
          <div class="msgBoxL">收款人姓名:</div>
          <el-input
            v-model="returnAccountParam.name"
            placeholder="请输入收款人姓名"
          ></el-input>

          <div class="msgBoxL">开户行:</div>
          <el-input
            v-model="returnAccountParam.bank_name"
            placeholder="请输入开户行信息"
          ></el-input>

          <div class="msgBoxL">银行卡号:</div>
          <el-input
            v-model="returnAccountParam.card_no"
            placeholder="请输入卡号"
          ></el-input>
        </div>
      </div>
      <div class="msgBox">
        <span>
          余额金额:
          <span style="color: red">{{ tabInfo.return_pet.pet_price }}</span>
        </span>
      </div>
      <div class="msgBox">
        <span>销售人员:</span>
        <el-select
          class="select"
          multiple
          v-model="curStaff"
          filterable
          placeholder="请选择"
        >
          <el-option
            popper-class="select"
            v-for="item in staffList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </div>
      <div style="height:40px;width:100%"></div>
      <div class="btnBox">
        <div class="btnItem" @click="close">取消</div>
        <div class="btnItem submit" @click="submit">确定</div>
      </div>
    </el-drawer>
    <!-- 支付弹窗 -->
    <div v-if="dialogSettlementState">
      <!-- returnGoods -->
      <dialogSettlement
        :type="'returnGoods'"
        :orderId="curOrder._id"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
  </div>
</template>
    
    <script>
import dialogSettlement from "../../../../components/dialog_settlement.vue";
export default {
  components: { dialogSettlement },
  props: {
    tabInfo: {
      default: {},
    },
  },
  data() {
    return {
      drawerStatus: false,
      formLabelWidth: "100px",
      remark: "",
      curStaff: [], // 销售人员
      staffList: [], //销售人员列表
      isReturnYuE: "true", //是否转余额
      // 支付弹窗
      dialogSettlementState: false,
      curOrder: {},
      // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
    };
  },
  computed: {},
  mounted() {
    console.log(this.tabInfo);
    this.getStaffList();
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
  },
  methods: {
    //创建活体退款
    submit() {
      if (this.$public.isNull(this.staffList)) {
        this.$message({
          type: "error",
          message: "销售人员不为空",
        });
        return;
      }
      if (this.isReturnYuE == "false") {
        let loading = this.$loading();
        let params = {
          id: this.tabInfo._id,
          isReturnYuE: this.isReturnYuE,
          returnYuEInfo: {},
          returnAccountParam: this.returnAccountParam,
        };
        var arr1 = [];
        this.staffList.forEach((itemA) => {
          this.curStaff.forEach((itemB) => {
            if (itemA.name === itemB) {
              const obj = {
                sales_id: itemA.id,
                sales_name: itemA.name,
              };
              arr1.push(obj);
            }
          });
        });
        params.returnYuEInfo.sales_list = arr1;
        console.log(params);
        this.$http
          .post("/api/ReturnOrder/Return/PetOweReturn", params)
          .then((res) => {
            console.log("不转余额欠宠退款", res);
            loading.close();
            if (res.code === 0) {
              this.curOrder._id = res.data;
              // this.dialogSettlementState = true;
              // this.$emit('submit', { type: 'close' })
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.remark = "";
            }
          });
      } else {
        let loading = this.$loading();
        let params = {
          id: this.tabInfo._id,
          isReturnYuE: this.isReturnYuE,
          returnYuEInfo: {},
          returnAccountParam: this.returnAccountParam,
        };
        var arr = [];
        this.staffList.forEach((itemA) => {
          this.curStaff.forEach((itemB) => {
            if (itemA.name === itemB) {
              const obj = {
                sales_id: itemA.id,
                sales_name: itemA.name,
              };
              arr.push(obj);
            }
          });
        });
        params.returnYuEInfo.sales_list = arr;
        console.log(params);
        this.$http
          .post("/api/ReturnOrder/Return/PetOweReturn", params)
          .then((res) => {
            console.log("转余额欠宠退款", res);
            loading.close();
            if (res.code === 0) {
              this.$emit("submit", { type: "close" });
              this.$message({
                message: "操作成功",
                type: "success",
              });
              // this.remark = '';
            }
          });
      }
    },
    dialogSettlementSubmit(a) {
      this.dialogSettlementState = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$emit("submit", { type: "close" });
      }
    },
    // 获取销售人员列表
    getStaffList() {
      let params = {
        keyword: "", //关键字
        pageIndex: 1,
        pageSize: 100,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          res.data.data.forEach((item) => {
            const obj = {
              id: item._id,
              name: item.basic_info.nick_name,
            };
            this.staffList.push(obj);
          });
          //   const name = this.tabInfo[0].staff.trim();
          //   this.staffList.forEach((item) => {
          //     if (item.name === name) {
          //       this.curStaff.push(item.name);
          //     }
          //   })
        }
      });
    },
    //清空输入框
    delInfo() {
      this.remark = "";
      this.returnAccountParam = {};
    },

    close() {
      this.$emit("submit", { type: "close" });
    },
  },
};
</script>
    
    <style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow: auto;
    }
  }
}
.msgBox {
  display: flex;
  padding: 10px;
  & > span {
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
  .msgBoxL {
    height: 56px;
    line-height: 56px;
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
.imgItem {
  position: relative;
  margin-right: 15px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
  background: #f0f0f7;
  border: 1px dashed #b0b0bf;
  border-radius: 8px;
  box-sizing: border-box;
}
.avatar {
  width: 128px;
  height: 128px;
  display: block;
  object-fit: cover;
}
.imgItem i {
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>
    